import React from 'react';
import { Outlet } from 'react-router-dom';
import HomeHeader from './HomeHeader';
import HomeFooter from './HomeFooter';
import styles from './HomeLayout.module.css';

const HomeLayout = () => {
  return (
    <div className={styles.homeLayout}>
      <HomeHeader />
      <main className={styles.mainContent}>
        <Outlet />
      </main>
      <HomeFooter />
    </div>
  );
};

export default HomeLayout;
